var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MainGroupFunctions, SubGroupFunctions, FilterPredicate } from "../../../typings";
import { observable, observe, computed, action } from "mobx";
import { createTransformer } from "mobx-utils";
import { EventsBySportIdRequest } from "sb-bff-integration";
import { MainGroupConfiguration, SubGroupConfiguration, CardType } from "../../../data";
import { getISODate, addHours, addDays, getEventTitle, getDailyHours, getDictPhrase, ComponentManager } from "../../../helpers";
import { StreamingFilterBlockConstant } from "../../../constants";
import { DeviceDetect } from "sb-resp-utils";
import { componentManagerConfig } from "../config";
var EventListPresenterState = /** @class */ (function () {
    function EventListPresenterState(provider, options) {
        this.EVENTS_CHUNK_SIZE = 20;
        this.provider = provider;
        this.options = options;
        this.deviceDetect = DeviceDetect.getInstance();
        this.sports = provider.sports;
        this.dateRange = provider.dateRange;
        this.mainGroupBy = options.cms.MainGroupBy;
        this.subGroupBy = options.cms.SubGroupBy;
        this.isFavoritesEnabled = this.provider.isFavoritesEnabled;
        this.isInFavoritesState = this.provider.isInFavoritesState;
        this.isMiniEventCard = this.provider.isMiniEventCard;
        this.showLiveFixturesAndOutrights = options.cms.ShowLiveFixturesAndOutrights;
        this.loader = this.provider.loader;
        this.componentManager = new ComponentManager(this.showLeagueInEventCard, this.options.cms.NumberOfSelectionsToShow, this.shouldShowOutrightSubheading, this.deviceDetect, this.options.dataProvider.componentManagerConfig || componentManagerConfig);
        this.displaySubheadings = createTransformer(this.displaySubheadings.bind(this));
        this.displayLeagues = createTransformer(this.displayLeagues.bind(this));
        this.displayHours = createTransformer(this.displayHours.bind(this));
        this.displayEvents = createTransformer(this.displayEvents.bind(this));
        this.displayMarkets = createTransformer(this.displayMarkets.bind(this));
        this.displaySports = createTransformer(this.displaySports.bind(this));
        this.displayDays = createTransformer(this.displayDays.bind(this));
        this.displayAllEvents = createTransformer(this.displayAllEvents.bind(this));
        this.displayEventsBySportId = createTransformer(this.displayEventsBySportId.bind(this));
        this.displayEventsByLeague = createTransformer(this.displayEventsByLeague.bind(this));
        this.displayEventsByTime = createTransformer(this.displayEventsByTime.bind(this));
        this.displayEventsByDay = createTransformer(this.displayEventsByDay.bind(this));
        this.displayEventByMainGrouping = createTransformer(this.displayEventByMainGrouping.bind(this));
        this.displayFavoriteEventsByLeague = createTransformer(this.displayFavoriteEventsByLeague.bind(this));
        this.displayEventsById = createTransformer(this.displayEventsById.bind(this));
        this.shouldShowCustomSubheading = createTransformer(this.shouldShowCustomSubheading.bind(this));
        this.filterOutrightWithMarkets = this.filterOutrightWithMarkets.bind(this);
        this.disposers = [];
        this.showOddBtns = false;
    }
    EventListPresenterState.prototype.shouldRenderSubheading = function (id) {
        return !this.displayEvents(id).length && !this.showFavoritesSection;
    };
    Object.defineProperty(EventListPresenterState.prototype, "tooltipMessage", {
        get: function () {
            return this.showOddBtns ? this.options.dict.HideAllOdds : this.options.dict.ShowAllOdds;
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.toggleOddsBtnOnClick = function () {
        this.showOddBtns = !this.showOddBtns;
        return this.showOddBtns;
    };
    EventListPresenterState.prototype.activate = function () {
        this.attachObservable();
        this.provider.activate();
    };
    EventListPresenterState.prototype.deactivate = function () {
        this.provider.deactivate();
        this.dettachObservable();
    };
    EventListPresenterState.prototype.attachObservable = function () {
        this.disposers = [
            observe(this.provider, this.updateProviderProps)
        ];
    };
    EventListPresenterState.prototype.updateProviderProps = function (change) {
        var provider = change.object;
        this.sports = provider.sports;
        this.dateRange = provider.dateRange;
        this.isFavoritesEnabled = provider.isFavoritesEnabled;
        this.isInFavoritesState = provider.isInFavoritesState;
        this.isMiniEventCard = provider.isMiniEventCard;
        this.loader = provider.loader;
    };
    EventListPresenterState.prototype.dettachObservable = function () {
        this.disposers.map(function (x) { return typeof x === "function" && x(); });
        this.disposers = [];
    };
    Object.defineProperty(EventListPresenterState.prototype, "isLoading", {
        get: function () {
            return this.isGroupedByTime ? this.loader.isFirstLoad : this.loader.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListPresenterState.prototype, "hasLoadEvents", {
        get: function () {
            return !this.isLoading && this.provider.data.events.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListPresenterState.prototype, "showLeagueInEventCard", {
        get: function () {
            return this.options.cms.ShowLeagueInEventCard && this.mainGroupBy !== MainGroupConfiguration.League
                && this.subGroupBy !== SubGroupConfiguration.League;
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.addToSlipTranspiler = function (market, selection) {
        var items = [{ eventId: market.eventId, marketId: market.id, selectionId: selection.id }];
        if (selection.isSelectionInBetslip) {
            return this.provider.sendBsUtilItemsRemoveMessage(items);
        }
        return this.provider.sendBsUtilItemsAddMessage(items);
    };
    EventListPresenterState.prototype.openGameTranspiler = function (event, ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        var openGameData = this.provider.getOpenGameData(event, ev);
        openGameData &&
            this.options.navHandler.OpenGame(openGameData.event, openGameData.id, openGameData.isLive, openGameData.evTypeForGameBlock, openGameData.shouldHideSidePanels, openGameData.branchID);
    };
    EventListPresenterState.prototype.manageFavorites = function (event, ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.provider.manageFavorites(event);
    };
    EventListPresenterState.prototype.openStatTranspiler = function (statisticsEventId, ev) {
        ev && ev.preventDefault();
        ev && ev.stopPropagation();
        this.provider.openStats(statisticsEventId, ev);
    };
    EventListPresenterState.prototype.openLiveStream = function (eventId, ev) {
        if (this.options.dataProvider.isLiveStreamHandlerEnabled && !this.isMiniEventCard) {
            this.provider.openLiveStream(eventId);
            ev && ev.preventDefault();
            ev && ev.stopPropagation();
        }
    };
    EventListPresenterState.prototype.changeSubGrouping = function (newGrouping) {
        this.subGroupBy = newGrouping;
        this.componentManager.showLeagueInEventCard = this.showLeagueInEventCard;
    };
    EventListPresenterState.prototype.openLeagueTranspiler = function (sportId, leagueId, ev, element) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenLeague(ev, leagueId, sportId, element);
    };
    EventListPresenterState.prototype.openViewAllLiveLink = function (ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        var sportId = this.sports.length ? this.sports[0] : 0;
        if (this.provider.isCurrentFilter(FilterPredicate.LiveStreaming)) {
            sportId = StreamingFilterBlockConstant;
        }
        this.options.navHandler.OpenGame(ev, 0, true, 0, 0, sportId);
    };
    EventListPresenterState.prototype.getViewAllLiveLink = function () {
        return this.options.navHandler.Navigation.getLiveBettingLink();
    };
    Object.defineProperty(EventListPresenterState.prototype, "displayMainHeadings", {
        // General display functions
        get: function () {
            var _this = this;
            return this[MainGroupFunctions[this.mainGroupBy].headings](this.sports[0])
                .filter(function (main) { return _this.displayEventByMainGrouping(main.id).length > 0; });
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.displaySubheadings = function (sportId) {
        var _this = this;
        var subheadings = this[SubGroupFunctions[this.subGroupBy].headings](sportId);
        return subheadings.map(function (sub) {
            sub.displayEvents = _this.displayEvents(sub.id);
            return sub;
        }).filter(function (sub) { return sub.displayEvents.length || _this.isFavouriteLeague(sub); });
    };
    EventListPresenterState.prototype.displayEvents = function (id) {
        var filteredEvents = this.shouldHideSubheadings ?
            this[MainGroupFunctions[this.mainGroupBy].events](id) :
            this[SubGroupFunctions[this.subGroupBy].events](id);
        return this.filterEventsByType(filteredEvents);
    };
    EventListPresenterState.prototype.displayMarkets = function (eventId) {
        return this.provider.data.markets.filter(function (x) { return x && x.eventId === eventId; });
    };
    // Display functions depending on current grouping
    // Main headings and Subheadings
    EventListPresenterState.prototype.displaySports = function (id) {
        var _this = this;
        var sportHeadings = [];
        this.sports.map(function (sportId) {
            var event = _this.provider.data.events.find(function (ev) { return ev.sportId === sportId; });
            event && sportHeadings.push({
                id: event.sportId,
                sportId: event.sportId,
                name: event.sportName
            });
        });
        return sportHeadings;
    };
    EventListPresenterState.prototype.displayLeagues = function (sportId) {
        var currentSportId = sportId;
        return this.provider.data.leagues.filter(function (l) { return l.sportId === currentSportId; });
    };
    EventListPresenterState.prototype.displayHours = function (sportId) {
        if (this.dateRange && this.dateRange.from) {
            var from = this.dateRange.from;
            var now = addHours(new Date(), this.provider.timeZone);
            var end = addDays(this.dateRange.from, 1);
            var isToday = from <= now && now <= end;
            if (isToday) {
                var hours = getDailyHours(now.getUTCHours());
                hours[0].name = this.options.dict.NextUp;
                return hours;
            }
        }
        return getDailyHours();
    };
    EventListPresenterState.prototype.displayDays = function (id) {
        var _this = this;
        var dates = {};
        this.provider.data.events.forEach(function (event) {
            var evDate = getISODate(event.startEventDate, _this.provider.timeZone);
            if (evDate) {
                var dateId = _this.getDayId(evDate);
                dates[dateId] = {
                    id: dateId.toString(),
                    sportId: _this.sports[0].toString(),
                    name: getDictPhrase(_this.options.dict, "day-" + evDate.getDay()),
                    subname: evDate.getDate() + " " + getDictPhrase(_this.options.dict, "month-" + evDate.getMonth())
                };
            }
        });
        return Object.keys(dates).map(function (key) { return dates[key]; });
    };
    EventListPresenterState.prototype.displayAllEvents = function (id) {
        var _this = this;
        return this.provider.data.events.filter(function (ev) {
            return _this.displayMarkets(ev.id).length > 0;
        })
            .map(function (ev) {
            return {
                id: ev.id,
                sportId: ev.sportId,
                name: getEventTitle(ev, _this.displayMarkets(ev.id)[0], _this.options.dict.EachWayTag)
            };
        });
    };
    // Events
    EventListPresenterState.prototype.displayEventsBySportId = function (sportId) {
        return this.provider.data.events.filter(function (event) { return event.sportId === sportId; });
    };
    EventListPresenterState.prototype.displayEventsByLeague = function (leagueId) {
        var events = this.provider.data.events.filter(function (ev) { return ev.leagueId === leagueId; });
        if (this.isInFavoritesState) {
            return this.filterFavoriteEvents(events, true);
        }
        if (this.showFavoritesSection) {
            return this.filterFavoriteEvents(events, false);
        }
        return events;
    };
    EventListPresenterState.prototype.displayEventsByTime = function (hour) {
        var _this = this;
        return this.provider.data.events.filter(function (ev) {
            var evDate = getISODate(ev.startEventDate, _this.provider.timeZone);
            return evDate && evDate.getHours().toString() === hour;
        });
    };
    EventListPresenterState.prototype.displayEventsByDay = function (id) {
        var _this = this;
        return this.provider.data.events.filter(function (event) {
            var evDate = getISODate(event.startEventDate, _this.provider.timeZone);
            var dateId = evDate && _this.getDayId(evDate).toString();
            return dateId === id;
        });
    };
    EventListPresenterState.prototype.displayEventByMainGrouping = function (id) {
        var events = this[MainGroupFunctions[this.mainGroupBy].events](id);
        if (this.isInFavoritesState) {
            return this.filterFavoriteEvents(events, true);
        }
        return events;
    };
    EventListPresenterState.prototype.displayEventsById = function (id) {
        var event = this.provider.data.events.find(function (ev) { return ev.id === id; });
        return event ? [event] : [];
    };
    Object.defineProperty(EventListPresenterState.prototype, "shouldHideSubheadings", {
        get: function () {
            return this.subGroupBy === SubGroupConfiguration.None;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListPresenterState.prototype, "displayFavoriteEvents", {
        get: function () {
            return this.provider.data.events.filter(function (ev) { return ev.isInFavorites; });
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.displayFavoriteEventsByLeague = function (id) {
        return this.provider.data.events.filter(function (ev) { return ev.isInFavorites && ev.leagueId === id; });
    };
    Object.defineProperty(EventListPresenterState.prototype, "displayFavoriteLeagues", {
        get: function () {
            var favoriteLeagues = this.displayFavoriteEvents.reduce(function (acc, ev) {
                acc[ev.leagueId] = { id: ev.leagueId, name: ev.leagueName, sportId: ev.sportId };
                return acc;
            }, {});
            return Object.keys(favoriteLeagues).map(function (key) { return favoriteLeagues[key]; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListPresenterState.prototype, "showFavoritesSection", {
        get: function () {
            return this.isFavoritesEnabled
                && !this.isInFavoritesState
                && this.displayFavoriteEvents.length > 0
                && this.subGroupBy === SubGroupConfiguration.League;
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.filterFavoriteEvents = function (events, showFavorites) {
        return events.filter(function (ev) { return showFavorites ? ev.isInFavorites : !ev.isInFavorites; });
    };
    Object.defineProperty(EventListPresenterState.prototype, "shouldShowOutrightSubheading", {
        get: function () {
            return this.mainGroupBy !== MainGroupConfiguration.Event || this.subGroupBy !== SubGroupConfiguration.None;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListPresenterState.prototype, "isGroupedByTime", {
        get: function () {
            return this.subGroupBy === SubGroupConfiguration.Time;
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.getSportCardType = function (sportId) {
        return this.getCardConfiguration(sportId).cardType;
    };
    EventListPresenterState.prototype.getCardConfiguration = function (sportId) {
        var cardConfig = this.options.dataProvider.cardConfiguration[sportId] || this.options.dataProvider.cardConfiguration[0];
        var miniCardConfig = this.isMiniEventCard && (this.options.dataProvider.cardConfigurationEventView[sportId] || this.options.dataProvider.cardConfigurationEventView[0]);
        return miniCardConfig || cardConfig;
    };
    EventListPresenterState.prototype.getMarketTemplates = function (sportId) {
        var cardItem = this.getCardConfiguration(sportId);
        var templates = cardItem.markets.map(function (m) { return m.template; });
        return templates;
    };
    EventListPresenterState.prototype.generateSubheadingId = function (mainHeadingId, subheadingId) {
        var dateId = (this.dateRange && this.dateRange.from) ? this.dateRange.from.getDate() + "-" : "";
        return mainHeadingId + "-" + dateId + subheadingId;
    };
    EventListPresenterState.prototype.shouldShowCustomSubheading = function (mainheading) {
        return this.deviceDetect.isDesktop
            && this.subGroupBy === SubGroupConfiguration.None
            && this.shouldShowNamesInHeading(mainheading)
            && this.displayEventByMainGrouping(mainheading.id).some(function (ev) { return ev.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString(); });
    };
    EventListPresenterState.prototype.shouldShowNamesInHeading = function (mainheading, isMainHeading) {
        var cardType = this.getSportCardType(mainheading.sportId);
        var shouldShowForDevice = this.deviceDetect.isDesktop && !this.isMiniEventCard;
        var shouldShowForCard = isMainHeading ? cardType === CardType.Multiview : (cardType === CardType.American || cardType === CardType.Multiview);
        return shouldShowForDevice && shouldShowForCard && this.shouldShowNamesInHeadingForEvents;
    };
    Object.defineProperty(EventListPresenterState.prototype, "shouldShowNamesInHeadingForEvents", {
        get: function () {
            if (this.mainGroupBy === MainGroupConfiguration.Event) {
                // Only outrights
                return false;
            }
            return this.provider.data.events.some(this.isFixture);
        },
        enumerable: true,
        configurable: true
    });
    EventListPresenterState.prototype.filterEventsByType = function (events) {
        var eventsWithMarkets = events.filter(this.filterOutrightWithMarkets);
        if (this.showLiveFixturesAndOutrights) {
            return eventsWithMarkets;
        }
        var fixtureEvents = eventsWithMarkets.filter(this.isFixture);
        return fixtureEvents.length ? fixtureEvents : eventsWithMarkets;
    };
    EventListPresenterState.prototype.isFixture = function (ev) {
        return ev.type !== EventsBySportIdRequest.EventTypesEnum.Outright.toString();
    };
    EventListPresenterState.prototype.filterOutrightWithMarkets = function (ev) {
        return ev.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() ? this.displayMarkets(ev.id).length > 0 : true;
    };
    EventListPresenterState.prototype.getEventsHeight = function (events) {
        var eventChunkHeights = [];
        var eventToShow = Math.min(events.length, this.options.cms.ExpandedEvents);
        var baseMinHeight = 0;
        var currentEvent = {};
        var isFirstChunk = true;
        var offsetToAdd = 0;
        for (var current = 0; current < eventToShow;) {
            baseMinHeight = 0;
            var numberOfEvents = Math.min(eventToShow - current, this.EVENTS_CHUNK_SIZE);
            for (var i_1 = 0; i_1 < numberOfEvents; i_1++) {
                currentEvent = events[current + i_1];
                var markets = this.displayMarkets(currentEvent.id);
                offsetToAdd = isFirstChunk
                    ? this.componentManager.getOffsetValue(currentEvent)
                    : 0;
                baseMinHeight += this.componentManager.getComponentHeight(currentEvent, markets) + offsetToAdd;
                isFirstChunk = false;
            }
            eventChunkHeights.push(baseMinHeight);
            var max = current + this.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);
        }
        return eventChunkHeights;
    };
    EventListPresenterState.prototype.getDayId = function (evDate) {
        return new Date(evDate.getFullYear(), evDate.getMonth(), evDate.getDate(), 0, 0, 0).getTime();
    };
    EventListPresenterState.prototype.isFavouriteLeague = function (sub) {
        return this.showFavoritesSection && this.displayFavoriteEvents.find(function (ev) { return ev.leagueId === sub.id; });
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], EventListPresenterState.prototype, "sports", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], EventListPresenterState.prototype, "dateRange", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], EventListPresenterState.prototype, "mainGroupBy", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], EventListPresenterState.prototype, "subGroupBy", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], EventListPresenterState.prototype, "isFavoritesEnabled", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], EventListPresenterState.prototype, "isInFavoritesState", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], EventListPresenterState.prototype, "isMiniEventCard", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], EventListPresenterState.prototype, "loader", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], EventListPresenterState.prototype, "showOddBtns", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "tooltipMessage", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EventListPresenterState.prototype, "toggleOddsBtnOnClick", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EventListPresenterState.prototype, "updateProviderProps", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "isLoading", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "hasLoadEvents", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "showLeagueInEventCard", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], EventListPresenterState.prototype, "changeSubGrouping", null);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "displayMainHeadings", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "shouldHideSubheadings", null);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "displayFavoriteEvents", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "displayFavoriteLeagues", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "showFavoritesSection", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "shouldShowOutrightSubheading", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "isGroupedByTime", null);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], EventListPresenterState.prototype, "shouldShowNamesInHeadingForEvents", null);
    return EventListPresenterState;
}());
export { EventListPresenterState };
//# sourceMappingURL=EventListPresenterState.js.map